import React from "react";

import Imagem1 from "../../../assets/images/beenius.png";

import './styles.css';

const Plataformas = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-sm-12">
                    <div className="imagem">
                    <img src={Imagem1} alt="foto"></img>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Plataformas;